import {
  Upload,
  Brain,
  ClipboardCheck,
  FileOutput,
} from 'lucide-react';

const steps = [
  {
    icon: Upload,
    title: 'Upload your tender pack',
    description: 'Drop PDFs, Word files, spreadsheets — 50+ formats supported.',
  },
  {
    icon: Brain,
    title: 'AI reviews every clause',
    description: 'Eligibility, compliance, evaluation weightings parsed in seconds.',
  },
  {
    icon: ClipboardCheck,
    title: 'Risk-scored assessment',
    description: 'Compliance matrix, risk flags, and bid/no-bid recommendation.',
  },
  {
    icon: FileOutput,
    title: 'Draft responses generated',
    description: 'Structured applications aligned to scoring criteria.',
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-it-works-section"
      className="section-spacing scroll-mt-24"
    >
      <div className="section-container">
        <div>
          {/* Centered heading */}
          <div className="text-center max-w-2xl mx-auto mb-12 sm:mb-16">
            <p data-animate className="kicker mb-4">How it works</p>
            <h2
              data-animate
              style={{ transitionDelay: '70ms' }}
              className="font-display text-2xl sm:text-3xl lg:text-[2.5rem] tracking-[-0.01em] leading-[1] lg:leading-[1.1] mb-4"
            >
              From document to decision<br className="md:hidden" /> in four steps.
            </h2>
            <p
              data-animate
              style={{ transitionDelay: '140ms' }}
              className="text-sm text-muted-foreground leading-relaxed"
            >
              No integrations. No training. Upload, review, decide.
            </p>
          </div>

          {/* Steps */}
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {steps.map((step, i) => {
                  const Icon = step.icon;
                  return (
                    <div
                      key={step.title}
                      data-testid="how-it-works-step"
                      data-animate
                      style={{ transitionDelay: `${i * 90}ms` }}
                      className="flex gap-4 p-5 rounded-2xl border border-border/50 bg-card shadow-card bento-card"
                    >
                      <div className="shrink-0 w-10 h-10 rounded-xl bg-primary/8 border border-primary/12 flex items-center justify-center">
                        <Icon className="w-5 h-5 text-primary" />
                      </div>
                      <div>
                        <div className="flex items-baseline gap-2 mb-1">
                          <span className="font-mono text-[10px] text-muted-foreground/40">0{i + 1}</span>
                          <h3 className="text-sm font-semibold text-foreground">{step.title}</h3>
                        </div>
                        <p className="text-xs text-muted-foreground leading-relaxed">
                          {step.description}
                        </p>
                      </div>
                    </div>
                  );
                })}
          </div>
        </div>
      </div>
    </section>
  );
}
